<script>
import DefaultHeader from "./header/DefaultHeader.vue";
import Footer from "./footer/Footer.vue";
export default {
  name: "DefaultLayout",
  components: { DefaultHeader, Footer }
};
</script>

<template>
  <div class="default-layout">
    <DefaultHeader />
    <router-view :key="$route.fullPath"></router-view>
    <Footer />
    <app-modal />
  </div>
</template>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.translate-enter-active,
.translate-leave-active {
  transition: transform 0.1s;
}

.translate-enter,
.translate-leave-to {
  transform: translate(100%);
}

.popup-enter-active,
.popup-leave-active {
  transition: opacity 0.1s;
}

.popup-enter,
.popup-leave-to {
  opacity: 0;
}

.default-layout {
  min-height: calc(var(--vh, 1vh) * 100);

  display: flex;
  flex-direction: column;

  .app-footer {
    margin-top: auto;
  }
}
</style>
